import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {selectSettings} from '../../features/settings';

import CalendarDay from './calendar-day';
import CalendarDayHoliday from './calendar-day-holiday';

import Card from 'react-bootstrap/Card';
import {isHolidayOrWeekend} from '../../features/holidays';
import UserIcon from './user-icon';
import CalendarRowLabel from './calendar-row-label';

//import {fetchUsers, selectUsers} from '../../features/users';

// import Card from 'react-bootstrap/Card';
// import {selectSettings} from '../../features/settings';

const UserCalendarLine = (props) => {
  const user = props.user;

  const settings = useSelector(selectSettings);

  const startDate = settings.date;
  const days = settings.displayDurationWeeks * 7;

  const holidays = useSelector(state => {
    return state.holidays.items;
  });

  const dayItems = [];

  dayItems.push(<CalendarDay key={-1} date={new Date('1970-01-01')} user={user} showHoursCount={false}/>);

  for (let i = 0; i < days; i++) {
    const date = new Date(startDate);
    date.setDate(date.getDate() + i);

    const isHoliday = isHolidayOrWeekend(holidays, date);

    if (isHoliday) {
      dayItems.push(<CalendarDayHoliday key={i} />);
    } else {
      dayItems.push(<CalendarDay key={i} date={date} user={user} showHoursCount={true}/>);
    }
  }

  return (
      <div className="card-group">

        <CalendarRowLabel label={user.name}/>

        <Card style={{width: settings.cardWidth + 'px', flex: 'auto', flexGrow: 0}}>
           <div className="m-2">
           <strong>{user.name}</strong>
             <p className="small">{user.description}</p>
               <UserIcon userUid={user.uid} />
           </div>
         </Card>

       {dayItems}
     </div>
  );
};

export default UserCalendarLine;
